// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { IOperation } from '@shared/undo/operation/i-operation';

@Injectable({providedIn: 'root'})
export class CopyPasteAdditionalOperations {

  private _operations: IOperation[];

  public clear() {
    this._operations = [];
  }

  public push(operation: IOperation) {
    this._operations.push(operation);
  }

  public pushMany(operations: IOperation[]) {
    this._operations = this._operations.concat(operations);
  }

  public get operations() {
    return this._operations;
  }
}
